/**
 * Merchant-scoped shared Assets — Contract v2.14 (Facade-Spec 514, Inc 1).
 * Quelle: `contracts/openapi-facade-admin-api-v2.14.yaml`. Felder camelCase
 * (eigene Serialisierung, NICHT der PascalCase-Service-Transformer).
 *
 * Inc-1-Scope: type ∈ {stylesheet, header, background, logo}. `legal`/Compliance
 * und `LogoAssetId`-Referenz sind vertagt (siehe Umsetzungs-Notiz).
 */

export type AssetType = 'stylesheet' | 'header' | 'background' | 'logo';

/** Service, der dieses Asset referenziert — ABGELEITET (BFF, nicht im Asset-Response). */
export interface AssetServiceUsage {
  serviceId: string;
  /** Admin-Label (Service.DisplayName) — Fallback auf die SVC_-ID. */
  displayName: string;
}

export interface MerchantAssetDerivatives {
  webp?: string;
  webp480?: string;
  webp800?: string;
  webp1440?: string;
}

export interface MerchantAsset {
  /** Server-vergeben, Form `AST_<unix-ts>_<8-hex>`. */
  assetId: string;
  merchantId: string;
  /** Sprechender Name, 1–200 Zeichen, NICHT unique. */
  name: string;
  type: AssetType;
  /** CDN-URL der aktuellen Datei. */
  currentFileUrl: string;
  status: 'active' | 'replaced' | 'deleted';
  /** Optimierte Varianten (WebP, Breakpoints) — read-only, Pipeline-generiert. */
  derivatives?: MerchantAssetDerivatives;
  createdAt: string;
  updatedAt: string;
  /**
   * ABGELEITET im BFF (Reverse-Index aus den Service-`…AssetId`-Feldern) —
   * nicht Teil des Contract-Asset-Schemas. Trägt das „in N Diensten"-Signal.
   */
  usedBy: AssetServiceUsage[];
  /**
   * ABGELEITET im BFF: true, wenn die Nutzungs-Ableitung gerade nicht ermittelbar
   * war (Service-List-Call fehlgeschlagen). Dann ist `usedBy` leer und die UI zeigt
   * „Nutzung nicht ermittelbar" statt „in 0 Diensten".
   */
  usageUnavailable?: boolean;
}

/** Create payload — `currentFileUrl` is mandatory (no metadata-only asset). */
export interface CreateMerchantAssetInput {
  merchantId: string;
  name: string;
  type: AssetType;
  currentFileUrl: string;
}

/** Partial update — `merchantId` required (scope), at least one of name/currentFileUrl. */
export interface UpdateMerchantAssetInput {
  merchantId: string;
  name?: string;
  currentFileUrl?: string;
}

export const ASSET_TYPE_ORDER: AssetType[] = ['background', 'header', 'logo', 'stylesheet'];

// Typ-Labels kommen aus dem i18n-Namespace `merchant-assets` (types.*).
